var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import { StyledAnchor } from './styled';
export const Link = forwardRef((props, forwardedRef) => {
    const { children, href, appearance = 'primary', underline = false, size = 'medium' } = props, restProps = __rest(props, ["children", "href", "appearance", "underline", "size"]);
    const externalLinkProps = href ? { target: '_blank', rel: 'noopener noreferrer' } : {};
    return (<StyledAnchor ref={forwardedRef} {...externalLinkProps} {...restProps} href={href} $appearance={appearance} $underline={underline} $size={size}>
      {children}
    </StyledAnchor>);
});
